$(function () {

  let formQuestions = $('#form-questions');
  let apiResult = '/resultado';

  let option = $('#form-questions').find('.option');
  let tab = $('.tab');
  let btnNext = $('.btn-next');
  let currentTab = 0;


  $('#comenzarPreguntas').on('click', (e) => {
    e.preventDefault();
    $('.overlay').removeClass('show');
    $('.modal').removeClass('show');
    $('body').css('overflow', 'initial');
  });

  option.on('change', ':radio', function (e) {

    var input = $(this);
    if (input.is(':checked')) {

      $(':radio[name="' + input.attr('name') + '"]')
        .parent()
        .parent()
        .removeClass('active');

      input.parents('.box-questions').find('.option').addClass('opacity');

      input.parent().parent()
        .removeClass('opacity')
        .addClass('active');
    }
  });

  formQuestions.validate({
    highlight: function (element) {
      let el = $(element);
      el.parents('.option').addClass('error');
    },
    unhighlight: function (element) {
      let el = $(element);
      el.parents('.option').removeClass('error');
    },
    errorPlacement: function (error, element) {}
  });

  showTab(currentTab);

  function showTab(n) {
    // tab[0].css('display', 'block');
    tab.eq(n).fadeIn();

    if ( n == tab.length - 1 ) {
      // btnNext.attr('type', 'submit');
      btnNext.text('ENVIAR');
    }
  }

  function nextPrev(n) {
    let isValid = formQuestions.valid();

    if ( !isValid ) return;

    if (currentTab >= tab.length - 1) {

      btnNext.attr('type', 'submit');

      formQuestions.submit();
      // formQuestions.submit( function(e) {
      //   e.preventDefault();

      //   alert('FALTA EL AJAX XDDDDDD. REDIRIGIENDO...');

      //   window.location = '/resultado';

      //   // $.ajax({
      //   //   url: apiResult,
      //   //   type: 'POST',
      //   //   contentType: 'application/x-www-form-urlencoded',
      //   //   data: formQuestions.serialize(),

      //   //   beforeSend: function (response) {

      //   //   },
      //   //   success: function (response) {
      //   //     console.log(response);
      //   //     console.log('ok');
      //   //   },

      //   //   error: function (response, rpta, created) {
      //   //     console.log(response);
      //   //     console.log('error');
      //   //   }
      //   // });
      // });
      return;
    }

    tab.eq(currentTab).hide();
    currentTab++;

    showTab(currentTab);
  }

  btnNext.on('click', nextPrev);

});
